import * as Types from '../../../__generated__/schema';

import { ActorTeaserAPIToken, ActorTeaserUser } from './ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from './ActorTeaser.generated';
export type CorrelationRule = Pick<
  Types.CorrelationRule,
  | 'body'
  | 'userOverrides'
  | 'createdAt'
  | 'description'
  | 'displayName'
  | 'enabled'
  | 'id'
  | 'lastModified'
  | 'managed'
  | 'outputIds'
  | 'parentId'
  | 'reference'
  | 'runbook'
  | 'severity'
  | 'simpleDetectionBody'
  | 'summaryAttributes'
  | 'tags'
  | 'versionId'
  | 'analysisType'
  | 'correlationRuleReferenceIds'
  | 'createAlert'
> & {
  createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser>;
  lastModifiedBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser>;
  tests: Array<
    Pick<Types.DetectionTestDefinition, 'expectedResult' | 'name' | 'resource'> & {
      mocks?: Types.Maybe<
        Array<Pick<Types.DetectionTestMockDefinition, 'objectName' | 'returnValue'>>
      >;
      ruleOutputs?: Types.Maybe<
        Array<Pick<Types.CorrelationRuleTestCaseRuleOutputDefinition, 'id' | 'matches'>>
      >;
    }
  >;
  reports: Array<Pick<Types.DetectionReportMapping, 'key' | 'values'>>;
};

export const CorrelationRule = gql`
  fragment CorrelationRule on CorrelationRule {
    body
    userOverrides
    createdAt
    createdBy {
      ...ActorTeaser
    }
    description
    displayName
    enabled
    id
    lastModified
    lastModifiedBy {
      ...ActorTeaser
    }
    managed
    outputIds
    parentId
    reference
    runbook
    severity
    simpleDetectionBody
    summaryAttributes
    tags
    tests {
      expectedResult
      name
      resource
      mocks {
        objectName
        returnValue
      }
      ruleOutputs {
        id
        matches
      }
    }
    versionId
    analysisType
    reports {
      key
      values
    }
    correlationRuleReferenceIds
    createAlert
  }
  ${ActorTeaser}
`;
